import type { FunctionComponent } from "react";

import { GrayCircle, StyledRadio, StyledTickIcon } from "./styles";

export const PlaybackRateRadio: FunctionComponent = props => (
  <StyledRadio checkedIcon={<StyledTickIcon />} icon={<GrayCircle />} {...props} />
);

PlaybackRateRadio.displayName = "PlaybackRateRadio";
